import Section2 from "../Home/Sections/Section2";
import Section4 from "../Home/Sections/Section4";
import React from 'react'
import Navbar from "../../navbar/Navbar";
import Footer from "../Home/Sections/Footer";

const About = () => {
  return (
    <main>
      <Navbar/>
      <Section2/>
      <Section4/>
      <Footer/>
    </main>
  )
}

export default About
